import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';

import {
  getConsolidatedForecastingUrl,
  getForecastingRouteUrl,
  matchConsolidationDetailRoutePath,
  PREDICT_PRODUCT_SLUG
} from '@futrli/shared-services';
import { ListingPageTabs } from '@futrli/ui-components/components/listing-page/listing-page-tabs/listing-page-tabs';
import { useNavHeight } from '@futrli/predict/hooks/useNavHeight';

import { CreateForecastPopover } from '../components/create-forecast-popover/create-forecast-popover';
import { ForecastActionsProvider } from '../context/forecast-actions-context/forecast-actions-context';
import { MyForecastsContainer } from './my-forecasts-container';
import { PerformanceComparisonContainer } from './performance-comparison-container';

export enum ForecastingTabId {
  FORECASTS_LIST = 'forecasts-list',
  PERFORMANCE_COMPARISON = 'performance-comparison'
}

export const ForecastingDashboardContainerNew = () => {
  const intl = useIntl();
  const { navHeight } = useNavHeight();
  const { workspaceId = '', organisationId = '' } = useParams();
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  const basePath = isConsolidation
    ? getConsolidatedForecastingUrl(workspaceId, organisationId, PREDICT_PRODUCT_SLUG)
    : getForecastingRouteUrl(workspaceId, organisationId);

  const tabs = useMemo(() => {
    return [
      {
        id: ForecastingTabId.FORECASTS_LIST,
        title: intl.formatMessage({
          id: 'forecasting.dashboard.forecasts_list',
          defaultMessage: 'Forecasts list'
        }),
        component: <MyForecastsContainer />
      },
      {
        id: ForecastingTabId.PERFORMANCE_COMPARISON,
        title: intl.formatMessage({
          id: 'forecasting.dashboard.performance_comparison',
          defaultMessage: 'Performance comparison'
        }),
        component: <PerformanceComparisonContainer />
      }
    ];
  }, [intl]);

  return (
    <ForecastActionsProvider>
      <Box margin="auto" padding="32px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h1" fontSize="24px" fontWeight="700" mb={0}>
            {intl.formatMessage({ id: 'forecasting.dashboard.title', defaultMessage: 'Forecasts' })}
          </Typography>
          <CreateForecastPopover />
        </Box>
        <Box mt={3}>
          <ListingPageTabs stickyTop={navHeight} tabs={tabs} basePath={basePath} mountActiveTabOnly />
        </Box>
      </Box>
    </ForecastActionsProvider>
  );
};
